import { render, staticRenderFns } from "./SettingsNavigation.vue?vue&type=template&id=e3d4db84"
import script from "./SettingsNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsNavigation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports